export default function getDayName() {
  const date = new Date()
  return date.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase()
}
